import React, { useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import AuctionFilter from "./AuctionFilter";
import useStyles from "./auction.style";
import AuctionCards from "./AuctionCards";
import { Box, Button, IconButton, Typography } from "@mui/material";
import Drawer from "@mui/material/Drawer";
// import routes from "../../constants/routes";
import MenuIcon from "@mui/icons-material/Menu";
import colorSchemes from "../../../constants/colorSchemes";
import { ChevronRight } from "@mui/icons-material";
import routes from "../../../constants/routes";
import getOrganiserDirectoryAPI from "../../../api/getOrganiserDirectoryAPI";

const LOT_STATUSES = ["live", "upcoming", "ended"];

function Auction(props) {
  const [eventIdFilter, setEventIdFilter] = useState("");
  // "Find Auctions by Organiser" links here with ?organiser=<userId>&status=
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const organiserFromLink = searchParams.get("organiser");
  const statusFromLink = LOT_STATUSES.includes(searchParams.get("status"))
    ? searchParams.get("status")
    : undefined;
  const [auctionIds, setAuctionId] = useState(
    organiserFromLink ? [organiserFromLink] : []
  );
  // the name comes with the click on the Organisers page; a link opened
  // directly looks it up
  const [organiserName, setOrganiserName] = useState(
    location.state?.organiserName
  );
  React.useEffect(() => {
    if (!organiserFromLink || organiserName) return;
    getOrganiserDirectoryAPI()
      .then(({ data }) => {
        const organiser = (data.data || []).find(
          ({ userId }) => userId === organiserFromLink
        );
        if (organiser) setOrganiserName(organiser.companyName);
      })
      .catch(() => {});
  }, [organiserFromLink, organiserName]);
  const showsLinkedOrganiser =
    organiserFromLink &&
    auctionIds.length === 1 &&
    auctionIds[0] === organiserFromLink;
  const [filterShow, setFilterShow] = useState(false);
  // side panel (wide screens) and drawer (phones) open separately - an open
  // drawer locks page scrolling even while it is hidden on a wide screen
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const { window, handleDetectRouteChange } = props;

  const [countryId, setCountryId] = React.useState("");
  const [stateId, setStateId] = React.useState("");

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };
  const filterProps = {
    setCountryId,
    setStateId,
    auctionIds,
    setAuctionId,
    eventIdFilter,
    setEventIdFilter,
  };
  const drawer = (
    <Box sx={{ textAlign: "center" }}>
      <AuctionFilter {...filterProps} setMobileOpen={setDrawerOpen} />
    </Box>
  );
  const classes = useStyles();
  const container =
    window !== undefined ? () => window().document.body : undefined;
  const drawerWidth = 340;

  return (
    <div
      className={classes.auction}
    >
      {mobileOpen ? (
        <Box className={classes.auctionFliter}>
          <AuctionFilter {...filterProps} setMobileOpen={setMobileOpen} />
        </Box>
      ) : (
        <div
          style={{
            background: "#2D55EB",
            height: "3rem",
            marginTop: "2rem",
            zIndex: "2",
            position: "absolute",
            display: "flex",
            alignItems: "center",
            padding: ".1rem",
            borderTopRightRadius: "2rem",
            borderBottomRightRadius: "2rem",
            transition: "all ease-in-out .3s",
            cursor: "pointer",
          }}
          onClick={() => setMobileOpen(true)}
        >
          <ChevronRight
            style={{
              fontSize: "2rem",
              fontWeight: "bold",
              color: "white",
            }}
          />
        </div>
      )}
      <div
        className={classes.auctionDetail}
        // the rest of the row next to the filter panel, so nothing is cut off
        style={mobileOpen ? { flex: 1, minWidth: 0 } : { width: "100%" }}
      >
        <Button
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{
            marginLeft: "0.7em",
            display: { sm: "none" },
            position: "absolute",
            backgroundColor: colorSchemes.primaryColor,
            color: "#fff",
            borderRadius: "0px",
            width: "95%",
          }}
        >
          <span>Filter</span>
        </Button>
        <Drawer
          container={container}
          variant="temporary"
          open={drawerOpen}
          aria-disabled={true}
          // onClose={() => setMobileOpen(true)}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        {showsLinkedOrganiser && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              flexWrap: "wrap",
              mt: 2,
            }}
          >
            <Typography sx={{ fontWeight: 600 }}>
              Organised by {organiserName || "the selected organiser"}
            </Typography>
            <Button
              size="small"
              variant="outlined"
              onClick={() => navigate(routes.organisers)}
            >
              ← All organisers
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={() => {
                setAuctionId([]);
                navigate(routes.auction, { replace: true });
              }}
            >
              Show all auctions
            </Button>
          </Box>
        )}
        <AuctionCards
          countryId={countryId}
          stateId={stateId}
          auctionIds={auctionIds}
          initialLotStatus={statusFromLink}
          stepper={props}
        />
      </div>
    </div>
  );
}

export default Auction;
